import { useMutation } from '@apollo/client';
import { useNavigation } from '@react-navigation/native';
import { showToast } from 'components/common/CustomToast';
import { REJECT_WAITING_LIST_APPROVAL } from 'graphql/mutations/rejectWaitingListApproval';
import { GET_UNIFIED_PERMITS } from 'graphql/queries/getUnifiedPermits';
import { useTranslation } from 'react-i18next';
import { usePermitStore } from 'stores/permitStore';
import {
  Mutation,
  MutationRejectWaitingListApprovalArgs,
} from 'types/generatedSchemaTypes';
import { useUiStore } from 'stores/uiStore';

export const useLeaveWaitingList = () => {
  const { t } = useTranslation();
  const { goBack } = useNavigation();

  const [rejectWaitingListApproval, { loading }] = useMutation<
    Mutation,
    MutationRejectWaitingListApprovalArgs
  >(REJECT_WAITING_LIST_APPROVAL);

  const leaveWaitingList = async (id: string) => {
    await rejectWaitingListApproval({
      variables: {
        id,
      },
      refetchQueries: [GET_UNIFIED_PERMITS],
      awaitRefetchQueries: true,
      onError: () => showToast(t('error.genericError')),
      onCompleted: () => {
        useUiStore.getState().setSheetModal('');
        usePermitStore.getState().setSelectedPermit(undefined);
        showToast(t('longTermParking.waitingList.left'), 'success');
        goBack();
      },
    });
  };

  return { leaveWaitingList, loading };
};
